import { z } from 'zod';
import { optionalNonNegativeIntString, optionalNonNegativeNumberString, requiredUuidString, } from '../zod-helpers/index.js';
import { MAX_VENDOR_PARTS_PER_CREATE, MAX_VENDOR_PARTS_PER_CREATE_MESSAGE, PART_CONSTRAINTS, } from './constraints.js';
import { checkPrimaryVendorCount } from './rules.js';
export const partVendorRowSchema = z.object({
    vendorId: requiredUuidString('Vendor is required.', 'Invalid vendor selection.'),
    vendorPartNumber: z
        .string()
        .trim()
        .min(1, 'Vendor part number is required.')
        .max(PART_CONSTRAINTS.vendorPartNumber.maxLength),
    defaultFlag: z.boolean(),
    lastCost: optionalNonNegativeNumberString(PART_CONSTRAINTS.vendorLastCost.label),
    leadTime: optionalNonNegativeIntString(PART_CONSTRAINTS.vendorLeadTime.label),
    qtyMin: optionalNonNegativeNumberString(PART_CONSTRAINTS.vendorQtyMin.label),
});
export const partVendorsEditFormSchema = z.object({
    vendors: z
        .array(partVendorRowSchema)
        .max(MAX_VENDOR_PARTS_PER_CREATE, MAX_VENDOR_PARTS_PER_CREATE_MESSAGE)
        .superRefine((vendors, context) => {
        const message = checkPrimaryVendorCount(vendors);
        if (message) {
            context.addIssue({ code: 'custom', message, path: [] });
        }
    }),
});
//# sourceMappingURL=vendors-form.js.map